import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';
import TimeMachineHologridImage from '../../images/TimeMachineHologrid.jpg';

export class TimeMachineHologrid extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Time Machine Hologrid</Popover.Title>
                <Popover.Content>
                    <img src={TimeMachineHologridImage} className="popover-images" alt="Time Machine Hologrid" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Time Machine Hologrid" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default TimeMachineHologrid
